import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-burger",
  "use": "foquz-icon-burger-usage",
  "viewBox": "0 0 25 17",
  "content": "<symbol viewBox=\"0 0 25 17\" fill=\"none\" id=\"foquz-icon-burger\"><path d=\"M0 0h25v3H0V0zm0 7h25v3H0V7zm0 7h25v3H0v-3z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol